import Telemetry from '@atlassian/mpac-telemetry';

/**  Tracks fetching and displaying the App Tiles in category page */
export const CategoryTask = Telemetry.createGenericTask('view-category-task');
